import api from "services/api";

let header = {
  Authorization: "bearer " + localStorage.getItem("teste"),
};
export const getByMenu = (menu, signal) => {
  return (dispatch) => {
    api.post("getScreening", header, menu, function (status, data) {
      if (signal?.aborted) return; // Verifica se o sinal foi abortado

      if (status === 200) {
        dispatch({
          type: "GET_CARDS",
          payload: data,
        });
      } else {
        dispatch({
          type: "GET_CARDS",
          payload: [],
        });
      }
    }, signal);
  };
};


export const postAcao = (model) => {
  api.post("postAcao", header, model, function (status, data) {
  });
};

export const updateCard = (model) => {
  return (dispatch) => {
    api.post("updateCard", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        dispatch({
          type: "CREATE_TAB",
          payload: data,
        });
      }
    });
  };
};

export const createCard = (model) => {
  return (dispatch) => {
    api.post("createCard", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        dispatch({
          type: "CREATE_TAB",
          payload: data,
        });
      }
    });
  };
};

export const deleteCard = (model) => {
  return (dispatch) => {
    api.post("deleteCard", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        dispatch({
          type: "CREATE_TAB",
          payload: data,
        });
      }
    });
  };
};

export const createTab = (model) => {
  return (dispatch) => {
    api.post("createTab", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200)
        dispatch({
          type: "CREATE_TAB",
          payload: data,
        });
    });
  };
};

export const updateTab = (model) => {
  return (dispatch) => {
    api.post("updateTab", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        dispatch({
          type: "CREATE_TAB",
          payload: data,
        });
      }
    });
  };
};

export const updateTabOrder = (model) => {
  return (dispatch) => {
    api.post("updateTab", header, model, function (status, data) {
    });
  };
};

export const deleteTab = (model) => {
  return (dispatch) => {
    api.post("deleteTab", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        dispatch({
          type: "CREATE_TAB",
          payload: data,
        });
      }
    });
  };
};

export const publishTab = (model) => {
  return (dispatch) => {
    api.post("publishTab", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200)
        dispatch({
          type: "PUBLISH_TAB",
          payload: data,
        });
    });
  };
};

export const createMenu = (model) => {
  return (dispatch) => {
    api.post("createMenu", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        
        dispatch({
          type: "CREATE_MENU",
          payload: data,
        });
      }
    });
  };
};

export const createMenuMult = (menus) => {
  return (dispatch) => {
    try {
      const promises = []
      menus.forEach(element => {
        promises.push(new Promise((r, j) => api.post("createMenu", header, element, function (status, data) {
          if (status === 200) r(status) 
          else j(status)
        })))
      });
      Promise.all(promises).then(() => {
        dispatch({
          type: "CREATE_MENU",
          payload: menus
        })
      })
      .catch((error) => {
      })
    } catch (error) {
    }
  };
};

export const updateMenu = (model) => {
  return (dispatch) => {
    api.post("updateMenu", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200)
        dispatch({
          type: "EDIT_MENU",
          payload: data,
        });
    });
  };
};

// Persiste a config "Claude Connected" do menu (colunas claude_*) no banco.
export const updateMenuClaude = (model) => {
  return (dispatch) => {
    api.post("updateMenuClaude", header, model, function (status, data) {});
  };
};

export const updateMenuChild = (model) => {
  return (dispatch) => {
    api.post("updateMenu", header, model, function (status, data) {});
  };
};

export const deleteMenu = (model) => {
  return (dispatch) => {
    api.post("deleteMenu", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200){
        
        dispatch({
          type: "DELETE_MENU",
          payload: data,
        });
        }
    });
  };
};

export const getMenus = (model) => {
  api.get("getMenu", header, model, function (status, data) {
  });
};

export const getUsuariosAdm = (area, user) => {
  let model = {
    params: {
      arg1: area,
      arg2: user,
    },
  };
  return (dispatch) => {
    api.post("getUsuarioAdm",header, model, function (status, data) {
      if (status === 200)
        dispatch({
          type: "GET_USUARIOS_ADM",
          payload: data,
        });
    });
  };
};


export const enableLocalFileTab = (model) => {
  return (dispatch) => {
    api.post("enableLocalFileTab", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        dispatch({
          type: "ENABLE_LOCAL_FILE_TAB",
          payload: data,
        });
      }
    });
  };
};

export const getAllAbas = (model) => {
  return (dispatch) => {
    api.get("getallcards", header, function (status, data) {
      if (status === 200) {
        dispatch({
          type: "GET_ALL_TABS",
          payload: data,
        });
      }
    });
  }
};


export const search = (model) => {
  return (dispatch) => {
    api.post("search", header, model, function (status, data) {
      if (status === 200) {
        dispatch({
          type: "SEARCH",
          payload: data,
        });
      }
    });
  };
};
